/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Tag } from '@zapier/design-system';

import { toSentenceCase } from 'app/developer-v3/utils';

import { IssueStatus, IssueType } from './constants';
import { WORK_STATUSES_DISPLAY } from '../constants';
import { IssueTagType } from './types';

const tagTypes = {
  [IssueType.FeatureRequest]: {
    color: 'warning' as const,
    text: IssueType.FeatureRequest,
  },
  [IssueType.Bug]: {
    color: 'error' as const,
    text: IssueType.Bug,
  },
  [IssueStatus.Open]: {
    color: 'success' as const,
    text: IssueStatus.Open,
  },
  [IssueStatus.Closed]: {
    color: 'PrimeBlack' as const,
    text: IssueStatus.Closed,
  },
  [IssueStatus.ClosePending]: {
    color: 'warning' as const,
    text: 'Close Requested',
  },
  [IssueStatus.Blocking]: {
    color: 'error' as const,
    text: IssueStatus.Blocking,
  },
  [WORK_STATUSES_DISPLAY.notStarted]: {
    color: 'error' as const,
    text: WORK_STATUSES_DISPLAY.notStarted,
  },
  [WORK_STATUSES_DISPLAY.planned]: {
    color: 'warning' as const,
    text: WORK_STATUSES_DISPLAY.planned,
  },
  [WORK_STATUSES_DISPLAY.inProgress]: {
    color: 'success' as const,
    text: WORK_STATUSES_DISPLAY.inProgress,
  },
};

type Props = {
  type: IssueTagType;
};

/**
 * Renders issue tag based on tagTypes and provided type
 * @param Props
 * @returns React.Element
 */
const IssueTag = ({ type }: Props) => {
  const { color, text } = tagTypes[type];

  return <Tag variant={color}>{toSentenceCase(text)}</Tag>;
};

export default IssueTag;
